// Constantes da aplicação

export const APP_CONFIG = {
  TITLE: import.meta.env.VITE_APP_TITLE || "MCP Server Frontend",
  VERSION: import.meta.env.VITE_APP_VERSION || "1.0.0",
  DEV_MODE: import.meta.env.VITE_DEV_MODE === "true",
  LOG_LEVEL: import.meta.env.VITE_LOG_LEVEL || "info",
} as const;

export const APP_CONSTANTS = {
  SESSION_TIMEOUT: 30 * 60 * 1000, // 30 minutos
  MAX_MESSAGE_LENGTH: 1000,
  MAX_RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 segundo
} as const;

export const BREAKPOINTS = {
  MOBILE: 640,
  TABLET: 768,
  DESKTOP: 1024,
  LARGE: 1280,
} as const;

export const ANIMATIONS = {
  DURATION: {
    FAST: 150,
    NORMAL: 300,
    SLOW: 500,
  },
  EASING: {
    EASE_IN: "cubic-bezier(0.4, 0, 1, 1)",
    EASE_OUT: "cubic-bezier(0, 0, 0.2, 1)",
    EASE_IN_OUT: "cubic-bezier(0.4, 0, 0.2, 1)",
  },
} as const;
